import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';

import { useLifeCountdown } from '../model/use-life-countdown';
import { LifeIcon } from './life-icon';

import classes from './life-recovery-notice.module.css';

type Props = {
  login?: string;
  action: ReactNode;
};

export const LifeRecoveryNotice = observer(({ login, action }: Props) => {
  const countdown = useLifeCountdown(login);

  return (
    <div className={classes.notice}>
      <span className={classes.icon} aria-hidden="true">
        <LifeIcon empty size={40} />
      </span>
      <div className={classes.copy}>
        <strong className={classes.title}>Жизни закончились</strong>
        <span className={classes.caption}>Продолжите после восстановления или пополните жизни в магазине.</span>
        {countdown && (
          <span className={classes.recovery}>
            <span>Следующая жизнь через</span>
            <strong role="timer" aria-label="До восстановления следующей жизни" aria-live="off">
              {countdown}
            </strong>
          </span>
        )}
      </div>
      <div className={classes.action}>{action}</div>
    </div>
  );
});
